
















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Mutation, Getter, namespace } from "vuex-class";

import supportMenu from "@/components/support/supportMenu.vue";
import { Auth } from "@/http/api/auth";
import { Support } from "@/http/api/support";

const HotelModule = namespace("HotelModule");

@Component({
  components: {
    supportMenu,
  },
})
export default class SupportLayout extends Vue {
  @HotelModule.State("hotelObjectId") hotelObjectId: any;
  @HotelModule.Action("setHotelObjectId") setHotelObjectId: any;

  @HotelModule.State("hotelInfo") hotelInfo: any;
  @HotelModule.Action("loadHotelAsync") loadHotelAsync: any;
  @HotelModule.Action("loadInfoAsync") loadInfoAsync: any;

  @HotelModule.Action("toHotelUrl") toHotelUrl: any;

  hotels = [];

  async mounted() {
    this.load();
  }

  async load() {
    try {
      await Promise.all([this.loadHotelAsync(), this.loadInfoAsync()]);

      if (this.hotelInfo?.userRole?.toLowerCase() !== "supporter") {
        this.$message.error("지원 페이지 접근 권한이 없습니다.");
        this.toHotelUrl({ path: "" });
        return;
      }

      this.hotels = await Support.simpleHotels();
    } catch {
      this.$message.error("지원 페이지 정보를 불러오지 못했습니다.");
      this.toHotelUrl({ path: "" });
    }
  }

  async logout() {
    try {
      await Auth.logout();
    } finally {
      this.toHotelUrl({ path: "" });
    }
  }

  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  change(value: any) {
    this.setHotelObjectId(value);
  }
}
